import React, { useState, useEffect } from "react";

import { toast } from "react-hot-toast";
import { useFormik } from "formik";
import Form from "react-bootstrap/Form";
import { Modal, Button } from "react-bootstrap";
import * as Yup from "yup";
import { baseUrl } from "../../../services/config";
import Upload from "../../Images/upload.png";
import Imagecard from "../Imagecard";
import { useLocation } from "react-router-dom";

const AddWallpaperModal = ({
  visible,
  handleCloseModal,
  reload,
  type,
  foldable,
  isFirst,
  LocationCheck,
}) => {
  const authToken = localStorage.getItem("userToken");
  
  // Original single image states
  const [img, setimg] = useState("");
  const [imgError, setimgError] = useState("");
  
  // New dual image states
  const [stretchedImage, setStretchedImage] = useState("");
  const [fullscreenImage, setFullscreenImage] = useState("");
  const [stretchedImageError, setStretchedImageError] = useState("");
  const [fullscreenImageError, setFullscreenImageError] = useState("");
  
  const [loading, setloading] = useState(false);
  
  const initialValues = {
    mainOption: "url", // Default to URL option
    url: "https://www.google.com", // Default Google URL
    navigation: "none", // Default to no navigation selected
  };

  const location = useLocation();
  const Location = location.pathname;

  const LoginSchema = Yup.object().shape({
    url: Yup.string().when('mainOption', {
      is: 'url',
      then: () => Yup.string()
        .required("Url is Required")
        .matches(
          /^(http[s]?:\/\/){0,1}(w{3,3}\.)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]/,
          "Url must begin with http or https:// and end with .com "
        ),
      otherwise: () => {
        // If LocationCheck is present, URL is always required
        if (!LocationCheck) {
          return Yup.string()
            .required("Url is Required")
            .matches(
              /^(http[s]?:\/\/){0,1}(w{3,3}\.)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]/,
              "Url must begin with http or https:// and end with .com "
            );
        }
        return Yup.string().notRequired();
      }
    }),
    navigation: Yup.string().when('mainOption', {
      is: 'navigation',
      then: () => Yup.string().oneOf(['gems', 'rewards'], 'Please select a navigation option'),
      otherwise: () => Yup.string().notRequired()
    })
  });

  const saveSide = (values, resetForm) => {
    console.log(values);
    const fdata = new FormData();
    fdata.append("type", type);
    
    // Handle URL based on LocationCheck or main option selection
    if (!LocationCheck || values.mainOption === "url") {
      fdata.append("url", values.url);
      // Set navigation options to false when URL is selected or LocationCheck is present
      fdata.append("is_navigate_to_gems", "0");
      fdata.append("is_navigate_to_rewards", "0");
    } else {
      // When navigation is selected, use Google as default URL
      fdata.append("url", "https://www.google.com");
      // Set navigation based on selection
      fdata.append("is_navigate_to_gems", values.navigation === "gems" ? "1" : "0");
      fdata.append("is_navigate_to_rewards", values.navigation === "rewards" ? "1" : "0");
    }
    
    // Conditional image appending based on LocationCheck
    if (LocationCheck) {
      // New behavior: Two separate images
      fdata.append("stretched_image", stretchedImage);
      fdata.append("fullscreen_image", fullscreenImage);
    } else {
      // Original behavior: Single image
      fdata.append("image", img);
    }

    let url1 = "admin/banners";
    let url2 = "admin/fold-able-banners";

    let urlToUse = url1;
    if (Location === "/native/mobile") {
      urlToUse = `${url1}?mobile_type=2`;
    } else {
      urlToUse = url1;
    }

    setloading(true);
    fetch(`${baseUrl}/${foldable ? url2 : urlToUse}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      body: fdata,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.metadata.success) {
          handleCloseModal();
          setloading(false);
          reload();
          resetForm();
          
          // Reset images based on LocationCheck
          if (LocationCheck) {
            setStretchedImage("");
            setFullscreenImage("");
            setStretchedImageError("");
            setFullscreenImageError("");
          } else {
            setimg("");
            setimgError("");
          }
        } else {
          setloading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }
    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {
      // Conditional validation based on LocationCheck
      if (LocationCheck) {
        // New behavior: Validate both images separately
        let hasError = false;
        
        // Validate stretched image
        if (!stretchedImage) {
          setStretchedImageError("Outer image is required");
          hasError = true;
        } else {
          setStretchedImageError("");
        }
        
        // Validate fullscreen image
        if (!fullscreenImage) {
          setFullscreenImageError("Inner image is required");
          hasError = true;
        } else {
          setFullscreenImageError("");
        }
        
        // Only proceed if both images are uploaded
        if (!hasError && stretchedImage && fullscreenImage) {
          saveSide(values, resetForm);
        }
      } else {
        // Original behavior: Validate single image
        if (img) {
          saveSide(values, resetForm);
        } else {
          setimgError("Image is required");
        }
      }
    },
  });

  return (
    <Modal
      show={visible}
      // show={true}
      onHide={handleCloseModal}
      animation={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 'bold', fontSize: '24px' }}>
          {type === "native" ? "Native" : type === "reward" ? "Reward" : "Side"}
        </Modal.Title>
      </Modal.Header>
      {loading === true ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="spinner-border text-dark p-5 m-5" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <Modal.Body className="row">
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework"
          >
            {/* Main Option Selection - Only show if LocationCheck is NOT present */}
            {LocationCheck && (
              <Form.Group className="mb-3 col-md-12">
                <Form.Label style={{ fontWeight: 'bold', fontSize: '18px' }}>Choose Option</Form.Label>
                <div className="mt-2 d-flex">
                  <Form.Check
                    type="radio"
                    id="option-url"
                    name="mainOption"
                    value="url"
                    label="URL"
                    checked={formik.values.mainOption === "url"}
                    onChange={formik.handleChange}
                    className="me-4"
                  />
                  <Form.Check
                    type="radio"
                    id="option-navigation"
                    name="mainOption"
                    value="navigation"
                    label="Navigation"
                    checked={formik.values.mainOption === "navigation"}
                    onChange={(e) => {
                      formik.handleChange(e);
                      // Reset navigation value when switching to navigation option
                      if (e.target.value === "navigation") {
                        formik.setFieldValue("navigation", "none");
                      }
                    }}
                    className="mx-2"
                  />
                </div>
              </Form.Group>
            )}

            {/* URL Field - Show when LocationCheck is present OR when URL option is selected */}
            {(!LocationCheck || formik.values.mainOption === "url") && (
              <Form.Group className="mb-3 col-md-12" controlId="formBasicEmail">
                <Form.Label>URL</Form.Label>
                <Form.Control
                  type="text"
                  name="url"
                  placeholder="URL"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses("url")}`}
                  {...formik.getFieldProps("url")}
                />
                {formik.touched.url && formik.errors.url ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.url}</div>
                  </div>
                ) : null}
              </Form.Group>
            )}

            {/* Navigation Options - Show only when LocationCheck is NOT present AND Navigation option is selected */}
            {!LocationCheck && formik.values.mainOption === "navigation" && (
              <Form.Group className="mb-3 col-md-12">
                <Form.Label style={{ fontWeight: 'bold', fontSize: '18px' }}>Choose Navigation</Form.Label>
                <div className="mt-2 d-flex">
                  <Form.Check
                    type="radio"
                    id="navigate-gems"
                    name="navigation"
                    value="gems"
                    label="Navigate to Gems"
                    checked={formik.values.navigation === "gems"}
                    onChange={formik.handleChange}
                    className="me-4"
                  />
                  <Form.Check
                    type="radio"
                    id="navigate-rewards"
                    name="navigation"
                    value="rewards"
                    label="Navigate to Subscription"
                    checked={formik.values.navigation === "rewards"}
                    onChange={formik.handleChange}
                    className="mx-2"
                  />
                </div>
                {formik.touched.navigation && formik.errors.navigation ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.navigation}</div>
                  </div>
                ) : null}
              </Form.Group>
            )}

            {/* Conditional File Upload based on LocationCheck */}
            {LocationCheck ? (
              // NEW: Two side-by-side uploads when LocationCheck is true
              <div className="col-12">
                <div className="row">
                

                  {/* Fullscreen Image Upload */}
                  <div className="col-md-6">
                    <div
                      className="avatar-upload-input text-center"
                      style={{ marginTop: "20px" }}
                    >
                      <img src={Upload} alt="img" />
                      <h2 className="mt-3">Upload Inner Image</h2>
                      <div className="avatar-edit-input">
                        <input
                          className="form-control form-control-solid h-auto py-5 px-6"
                          style={{ textAlignLast: "center" }}
                          type="file"
                          onChange={(e) => {
                            setFullscreenImageError("");
                            setFullscreenImage(e.target.files[0]);
                          }}
                          name="fullscreen_image"
                          id="fullscreenImageUpload"
                          accept=".png, .jpg, .jpeg"
                        />
                        {fullscreenImage && (
                          <div className="text-success mt-2">
                            <small>✓ {fullscreenImage.name}</small>
                          </div>
                        )}
                        {fullscreenImageError ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block text-danger">{fullscreenImageError}</div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                    {/* Stretched Image Upload */}
                  <div className="col-md-6">
                    <div
                      className="avatar-upload-input text-center"
                      style={{ marginTop: "20px" }}
                    >
                      <img src={Upload} alt="img" />
                      <h2 className="mt-3">Upload Outer Image</h2>
                      <div className="avatar-edit-input">
                        <input
                          className="form-control form-control-solid h-auto py-5 px-6"
                          style={{ textAlignLast: "center" }}
                          type="file"
                          onChange={(e) => {
                            setStretchedImageError("");
                            setStretchedImage(e.target.files[0]);
                          }}
                          name="stretched_image"
                          id="stretchedImageUpload"
                          accept=".png, .jpg, .jpeg"
                        />
                        {stretchedImage && (
                          <div className="text-success mt-2">
                            <small>✓ {stretchedImage.name}</small>
                          </div>
                        )}
                        {stretchedImageError ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block text-danger">{stretchedImageError}</div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              // ORIGINAL: Single upload when LocationCheck is false
              <div className="col-12">
                <div
                  className="avatar-upload-input text-center"
                  style={{ marginTop: "20px" }}
                >
                  <img src={Upload} alt="img" />
                  <h2 className="mt-3">Upload File</h2>
                  <div className="avatar-edit-input">
                    <input
                      className="form-control form-control-solid h-auto py-5 px-6"
                      style={{ textAlignLast: "center" }}
                      type="file"
                      onChange={(e) => {
                        setimgError("");
                        setimg(e.target.files[0]);
                      }}
                      name="image"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                    />
                    {imgError ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">{imgError}</div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            )}
          </form>
        </Modal.Body>
      )}
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          Close
        </Button>
        <Button type="submit" variant="primary" onClick={formik.handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddWallpaperModal;